module.exports = __webpack_public_path__ + "assets/img/soldiers_2.dab925f6.png";